export function PageHeader({ eyebrow, title, action, subtitle }) {
    return (
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
            <div>
                <div className="eyebrow mb-3">{eyebrow}</div>
                <h1 className="font-serif text-4xl lg:text-5xl leading-tight tracking-tight">{title}</h1>
                {subtitle && <p className="text-sm text-muted2 mt-3 max-w-2xl">{subtitle}</p>}
            </div>
            {action}
        </div>
    );
}

export function Stat({ label, value, accent }) {
    return (
        <div className={`border ${accent ? "border-terracotta/50 bg-terracotta/5" : "border-espresso/15"} p-6`}>
            <div className="eyebrow mb-3">{label}</div>
            <div className="font-serif text-4xl text-ink">{value}</div>
        </div>
    );
}

export function AdminField({ label, value, onChange, type = "text", testid }) {
    return (
        <div>
            <label className="eyebrow block mb-2">{label}</label>
            <input data-testid={testid} type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="w-full border border-espresso/20 px-3 py-2 text-sm bg-transparent focus:border-forest outline-none" />
        </div>
    );
}
